<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="orderInvoiceModal"
      persistent
      max-width="1000px"
    >
      <v-card>
        <form @submit.prevent="submitForm()">
          <v-card-title>
            <div class="headline">
              Generate Invoice
            </div>
          </v-card-title>
          <v-card-text class="pt-0 px-4">
            <div class="row" style="margin:5px 0; background-color: #FAF8F8FF;border:1px solid #bbb; border-radius: 5px;">
              <div class="col-12 col-sm-6">
                <h5>Customer: {{ formData.customer_name }}</h5>
              </div>
              <div class="col-12 col-sm-6">
                <h5>Phone number: {{ formData.phone }}</h5>
              </div>

              <div
                v-if="formData.orders && formData.orders.length > 0"
                class="col-12 col-sm-12"
              >
                <h5>Orders</h5>
              </div>
              <div
                v-if="formData.orders && formData.orders.length > 0"
                class="col-12 col-sm-12"
              >
                <div class="d-flex flex-wrap">
                  <div
                    v-for="(order, index) in formData.orders"
                    :key="index"
                    class="mr-3 mb-2 d-flex align-center"
                  >
                    <h6 style="display: inline; margin: 0">#{{ order.the_order_id }}
                      <i
                      class="fa fa-remove ml-2"
                      style="font-size: 16px; color: red; cursor: pointer"
                      @click="removeOrder(index)"
                    ></i>
                    </h6>

                  </div>
                </div>
              </div>
              </div>
              <div class="row">

              <!-- <div class="col-12">
                <branch-select v-model="formData.branch_id_fk" />
              </div> -->

                  <div class="col-6 col-sm-4">
                    <v-select
                      label="Warehouse"
                      v-model="formData.warehouse_id"
                      :items="warehouses"
                      :error-messages="errors.collect('Warehouse')"
                      v-validate="'required'"
                      @input="isShipmentManual = false,isHandlingFeeManual = false,handleSelectWarehouse(formData.warehouse_id)"
                      data-vv-name="Warehouse"
                      item-text="text"
                      item-value="value"
                    />
                  </div>

                  <div class="col-6 col-sm-4">
                    <v-select
                      :items="transportationTypes"
                      item-value="id"
                      item-text="name"
                      v-model="transportation_type"
                      :error-messages="errors.collect('Transportation Type')"
                      @input="isShipmentManual = false,isHandlingFeeManual = false,getCustomerPriceList()"
                      data-vv-name="Transportation Type"
                      label="Transportation Type*"
                    >
                    </v-select>
                  </div>

                  <div class="col-6 col-sm-4">
                    <v-select
                      label="Order Type"
                      v-model="formData.order_type_id"
                      :items="orderTypes"
                      :error-messages="errors.collect('order_type_id')"
                      v-validate="'required'"
                      @input="handleOrderTypeChange"
                      data-vv-name="order_type_id"
                      item-text="text"
                      item-value="value"
                    />
                  </div>

              <div class="col-12 col-sm-3">
                <v-text-field
                  label="Weight"
                  v-model="formData.weight"
                  :error-messages="errors.collect('Weight')"
                  @input="isShipmentManual = false,isHandlingFeeManual = false,calculateTotalAmount()"
                  v-validate="'required'"
                  data-vv-name="Weight"
                />
              </div>

              <div class="col-12 col-sm-3">
                <v-text-field
                  label="Volume"
                  v-model="formData.volume"
                  @input="isShipmentManual = false,isHandlingFeeManual = false,calculateTotalAmount()"
                />
              </div>

              <div class="col-12 col-sm-3">
                <v-text-field
                  label="Shipment"
                  v-model.number="shipment"
                  @input="handleShipmentInput()"
                  :error-messages="errors.collect('Shipment')"
                  v-validate="'required|decimal:2'"
                  data-vv-name="Shipment"
                />
              </div>

              <div class="col-12 col-sm-3">
                <v-text-field
                  label="Tax"
                  v-model.number="formData.tax"
                  @input="calculateTotalAmount()"
                  :error-messages="errors.collect('Tax')"
                  v-validate="'decimal:2'"
                  data-vv-name="Tax"
                />
              </div>

              <div class="col-12 col-sm-3">
                <v-text-field
                  label="Delivery price"
                  v-model.number="formData.delivery_price"
                  @input="calculateTotalAmount()"
                  :error-messages="errors.collect('Delivery price')"
                  v-validate="'decimal:2'"
                  data-vv-name="Delivery price"
                />
              </div>

              <div v-if="formData.is_ship_only == 1" class="col-12 col-sm-3">
                <v-text-field
                  label="Handling Fee"
                  v-model.number="shiponly_handle_fee"
                  :error-messages="errors.collect('Handling Fee')"
                  @input="handleHandlingFeeInput"
                  v-validate="'required|decimal:2'"
                  data-vv-name="Handling Fee"
                />
              </div>

              <div class="col-12 col-sm-3">
                <v-text-field
                  label="Discount"
                  v-model.number="formData.discount"
                  @input="calculateTotalAmount()"
                  :error-messages="errors.collect('Discount')"
                  v-validate="'decimal:2'"
                  data-vv-name="Discount"
                />
              </div>
              <div class="row"></div>

              <div class="col-12 col-sm-6">
                <v-text-field
                  label="Total price"
                  v-model.number="formData.total_price"
                  readonly
                  :error-messages="errors.collect('Total price')"
                  v-validate="'required|decimal:2'"
                  data-vv-name="Total price"
                  class="orange-text"
                />
              </div>

              <div class="col-12 col-sm-6">
                <v-text-field
                  label="Net price"
                  v-model.number="formData.net_price"
                  readonly
                  :error-messages="errors.collect('Net price')"
                  v-validate="'required|decimal:2'"
                  data-vv-name="Net price"
                />
              </div>

              <div class="col-12 col-sm-6">
                <v-text-field
                  label="Paid amount"
                  v-model="formData.paid_amount"
                  :error-messages="errors.collect('Paid amount')"
                  v-validate="'decimal:2'"
                  data-vv-name="Paid amount"
                />
              </div>

              <div class="col-12">
                <v-text-field
                  label="Note"
                  v-model="formData.note"
                />
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="$emit('close')"
              style="height:auto"
              outline
            >Cancel</v-btn>
            <v-btn
              type="submit"
              style="height:auto"
              outline
              color="primary"
            >Save</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from 'axios'
import { set } from 'lodash'
import swal from 'sweetalert'

export default {
  props: {
    orderInvoiceModal: {},
    formData: {},
    is_second_invoice: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      warehouses: [],
      apiCustomerPrice: [],
      transportationTypes: [],
      orderTypes: [],
      shiponly_handle_fee: 0,
      shipment: 0,
      transportation_type: null,
      isHandlingFeeManual: false,
      isShipmentManual: false
    }
  },

  watch: {
    orderInvoiceModal(newValue) {
      if (newValue) {
        this.getWarehouses()
      }
    }
  },

  methods: {
    getWarehouses() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let result = response.data.data
          result.forEach((r) => {
            this.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types })
          })
        }).finally(() => {
          if (this.formData.warehouse_id) {
            this.handleSelectWarehouse(this.formData.warehouse_id)
          }
        })
    },

    getCustomerPriceList() {
      var token = localStorage.getItem('access_token')
      let params = {
        customer_id_fk: this.formData.customer_id,
        warehouse_id_fk: this.formData.warehouse_id,
        order_type_id_fk: this.formData.order_type_id
      }
      axios
        .post('api/subscription-pricing/customer-price', params, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          let data = response.data
          this.apiCustomerPrice = data.data
          this.formData.shiponly_handling_fee = this.transportation_type === 1 ? data.data.shiponly_handling_fee_air : data.data.shiponly_handling_fee_sea
          this.formData.shipment = this.transportation_type === 1 ? data.data.item_price_air : this.transportation_type === 2 ? data.data.item_price_sea : data.data.item_price_land
          this.isHandlingFeeManual = false
          this.isShipmentManual = false
        })
        .catch((errors) => { })
        .finally(() => {
          this.calculateTotalAmount()
        })
    },

    getOrderTypes() {
      let token = localStorage.getItem('access_token')
      axios
        .get(`api/subscription-pricing/get-order-types/` + this.formData.warehouse_id, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let result = response.data.data
          this.getCustomerPriceList()
          this.orderTypes = [] // Clear existing order types
          result.forEach((r) => {
            this.orderTypes.push({
              text: r.type_name,
              value: r.order_type_id,
              type_price_air: r.type_price_air,
              type_price_sea: r.type_price_sea,
              type_price_land: r.type_price_land
            })
          })
          this.getCustomerPriceList()
        })
    },

    handleOrderTypeChange() {
      this.isShipmentManual = false
      this.isHandlingFeeManual = false
      this.getCustomerPriceList()
    },

    handleSelectWarehouse(id) {
      this.transportation_type = null
      const warehouse = this.warehouses.find(w => w.value === id)

      if (warehouse) {
        this.transportationTypes = warehouse.transportation_types
      }
      this.transportation_type = this.formData.transportation_type


      this.getOrderTypes()
    },

    removeOrder(index) {
      this.formData.orders.splice(index, 1)
    },

    handleHandlingFeeInput() {
      this.isHandlingFeeManual = true
      this.calculateTotalAmount()
    },

    handleShipmentInput() {
      this.isShipmentManual = true
      this.calculateTotalAmount()
    },

    calculateTotalAmount() {
      let tax = Number(this.formData.tax) || 0
      let deliveryPrice = Number(this.formData.delivery_price) || 0
      let discount = Number(this.formData.discount) || 0

      if (this.formData.is_ship_only == 1 && !this.isHandlingFeeManual) {
        this.shiponly_handle_fee = parseFloat((Math.max(this.formData.volume, this.formData.weight) * this.formData.shiponly_handling_fee || 0).toFixed(2))
      } else if (this.formData.is_ship_only != 1) {
        this.shiponly_handle_fee = 0
      }

      if (!this.isShipmentManual) {
        this.shipment = parseFloat((Math.max(this.formData.volume, this.formData.weight) * this.formData.shipment || 0).toFixed(2))
      }

      const total = Number(this.shipment) + tax + deliveryPrice + Number(this.shiponly_handle_fee)
      this.formData.handling_fee = this.shiponly_handle_fee
      this.formData.total_price = total.toFixed(2)
      this.formData.net_price = (total - discount).toFixed(2)
    },

    submitForm() {
      if (this._submitTimeout) {
        return
      }
      this._submitTimeout = setTimeout(() => {
        this._submitTimeout = null
      }, 500)

      // if (this.formData.orders.length === 0) {
      //   swal('Warning', 'Please at least select one order', 'error')
      //   return
      // }

      this.$validator.validateAll().then((res) => {
        if (res) {
          let token = localStorage.getItem('access_token')
          this.formData.is_second_invoice = this.is_second_invoice
          axios
            .post('api/order_invoice', this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(() => {
              swal({
                title: 'Done',
                text: 'Invoice generated successfully',
                icon: 'success',
                timer: 750,
                buttons: false
              })
              this.$emit('invoice-created')
              this.$emit('close')
            })
            .catch((err) => {
              swal('Warning', err.response.data.message, 'error')
            })
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
.dialog {
  overflow-y: auto !important;
  overflow-x: hidden;
}

.orange-text .v-input__slot {
  color: #ce7706 !important;
}
.orange-text input {
  color: #ce7706 !important;
}
.orange-text label {
  color: #ce7706 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/orderInvoice/AddOrderInvoice.vue